// src/components/heroManagementDashboard/systemUtils/step9AuditReviewHelpers/Step9AuditReviewFunctions.js
import React from "react";
import MultiStyleButton from "../MultiStyleButton";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const serializeValue = (value, depth = 0) => {
  if (value === null || value === undefined) return "N/A";
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return value.toString();
  }
  if (Array.isArray(value)) {
    if (value.length === 0) return "None";
    return (
      <ul className={`step9-audit-nested-list depth-${depth}`}>
        {value.map((item, idx) => (
          <li key={idx}>{serializeValue(item, depth + 1)}</li>
        ))}
      </ul>
    );
  }
  if (typeof value === "object") {
    return (
      <ul className={`step9-audit-nested-list depth-${depth}`}>
        {Object.entries(value).map(([key, val]) => (
          <li key={key}>
            <strong>{key}:</strong> {serializeValue(val, depth + 1)}
          </li>
        ))}
      </ul>
    );
  }
  console.log("Serializing unknown value:", { value, type: typeof value });
  return "Unknown";
};

export const renderDocumentsReviewed = (
  extractedDataPointsResults,
  isOCRdocument,
  handleViewDocument
) => {
  if (
    !extractedDataPointsResults ||
    Object.keys(extractedDataPointsResults).length === 0
  ) {
    return <p>No documents have been reviewed.</p>;
  }
  console.log(extractedDataPointsResults);
  Object.entries(extractedDataPointsResults).forEach(
    ([documentName, documentData]) => {
      console.log(`Document Name: ${documentName}`);
      console.log(
        `Document Type: ${
          documentData.documentType || "No description provided."
        }`
      );
    }
  );

  return (
    <table className="data-points-table">
      <thead>
        <tr>
          <th>Document Name</th>
          <th>Description</th>
          <th>OCR</th>
          <th>View Document</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(extractedDataPointsResults).map(
          ([documentName, documentData], index) => (
            <tr key={index}>
              <td>{documentName}</td>
              <td>{documentData.documentType || "No description provided."}</td>
              <td>
                {isOCRdocument?.[documentName] !== undefined ? (
                  isOCRdocument[documentName] ? (
                    <span className="ocr-status ocr-yes">
                      <FaCheckCircle /> Yes
                    </span>
                  ) : (
                    <span className="ocr-status ocr-no">
                      <FaTimesCircle /> No
                    </span>
                  )
                ) : (
                  "Not Available"
                )}
              </td>
              <td>
                <MultiStyleButton
                  label="View"
                  buttonType="approve"
                  onClick={() => handleViewDocument(documentName)}
                />
              </td>
            </tr>
          )
        )}
      </tbody>
    </table>
  );
};

export const renderDataPoints = (
  dataPoints,
  handleRejectDataPoint,
  handleSelectDataPoint,
  handleRestoreDataPoint
) => {
  if (!dataPoints || dataPoints.length === 0) {
    return <p>No data points available.</p>;
  }

  return (
    <table className="data-points-table">
      <thead>
        <tr>
          <th>Field Name</th>
          <th>Value</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {dataPoints.map((dp, index) => {
          let actionContent;
          if (dp.status === "unresolved") {
            if (dp.rejected) {
              actionContent = (
                <MultiStyleButton
                  label="Restore"
                  buttonType="approve"
                  onClick={() => handleRestoreDataPoint(dp.fieldName)}
                />
              );
            } else {
              actionContent = <span>Select Value to Resolve</span>;
            }
          } else if (dp.status === "resolved") {
            actionContent = (
              <MultiStyleButton
                label="Reject"
                buttonType="cancel"
                onClick={() => handleRejectDataPoint(dp.fieldName)}
              />
            );
          }

          return (
            <tr key={index}>
              <td>{dp.fieldName}</td>
              <td>
                {dp.status === "resolved" ? (
                  serializeValue(dp.value)
                ) : dp.conflictingValues && dp.conflictingValues.length > 0 ? (
                  <table className="nested-table">
                    <thead>
                      <tr>
                        <th>Source</th>
                        <th>Value</th>
                        <th>Select</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dp.conflictingValues.map((cv, idx) => (
                        <tr key={idx}>
                          <td>{cv.documentName || "N/A"}</td>
                          <td>{serializeValue(cv.value)}</td>
                          <td>
                            <MultiStyleButton
                              label="Select"
                              buttonType="approve"
                              onClick={() =>
                                handleSelectDataPoint(dp.fieldName, cv.value)
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  "No value available"
                )}
              </td>
              <td className={`datapoint-status ${dp.status}`}>
                {dp.status === "resolved" ? (
                  <>
                    <FaCheckCircle /> Resolved
                  </>
                ) : dp.status === "unresolved" ? (
                  <>
                    <FaTimesCircle /> Unresolved
                  </>
                ) : (
                  dp.status.charAt(0).toUpperCase() + dp.status.slice(1)
                )}
              </td>
              <td>{actionContent}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export const getRiskClass = (score) => {
  if (!score) return "";
  switch (score.toLowerCase()) {
    case "high":
    case "advise not to proceed":
      return "risk-high";
    case "medium":
    case "proceed with caution":
      return "risk-medium";
    case "low":
    case "proceed":
      return "risk-low";
    default:
      return "";
  }
};

export const renderFinalDataPoints = (dataPointsState) => {
  if (!dataPointsState || dataPointsState.length === 0) {
    return <p>No data points available.</p>;
  }

  return (
    <table className="data-points-table">
      <thead>
        <tr>
          <th>Field Name</th>
          <th>Final Value</th>
        </tr>
      </thead>
      <tbody>
        {dataPointsState.map((dp, index) => (
          <tr key={index}>
            <td>{dp.fieldName}</td>
            <td>{serializeValue(dp.value) || "No value available"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};